import {useTranslation} from 'react-i18next';
import {Tooltip, TooltipContent, TooltipProvider, TooltipTrigger} from '../tooltip';
import {StatusBadge} from '../status-badge';

export type CommingSoonBadgeProps = {
  tooltip?: boolean;
};

export function CommingSoonBadge({tooltip = true}: CommingSoonBadgeProps) {
  const {t} = useTranslation();

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <StatusBadge textOnly variant="success-blue">
            {t('feature_coming_soon')}
          </StatusBadge>
        </TooltipTrigger>
        {tooltip && (
          <TooltipContent variant="dark">
            <p className="w-[216px] text-balance">
              {t('feature_coming_soon_description')}
            </p>
          </TooltipContent>
        )}
      </Tooltip>
    </TooltipProvider>
  );
}
